import styled from 'styled-components';
import { PrimaryColor } from '../../utils/StyleVariables';

export const SolutionsStyles = styled.div`
     h1{
        text-align: center;
        font-family: "Merriweather", sans-serif;
        font-weight: 700;
        color: ${PrimaryColor};
        font-size: 40px;
        margin-bottom: 0;
        font-size: 30px;
        margin-top: 50px;
    }
`;

export const SolutionHeader = styled.div`
    min-height: 200px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 120px;
    background-color: #f9f9f9;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    .lottie-spotlight {
        width: 60%;
    }

`;

export const SolutionCardStyles = styled.div`
padding: 10px 5px;
    border: 2px solid ${PrimaryColor};
    border-radius: 20px;
    width: 300px;
    height: 100px;

    &:hover{
    outline: 3px solid #00A651;
    background-color: #00A651;
    color: white;
   
    }

    p{
        font-size: 20px;
    }
`;
